export const ALL_ACCOUNTS = [0, 1, 2, 3, 4];
